
/**
 * Bad request
 */
export type BadRequestResponse = void;
